import React from 'react'
import { change as changeFieldValue, Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Select from 'react-select';
import axios from 'axios';
import $ from 'jquery';
import cadastrarUsuario from '../../../actions/usuario/cadastrarUsuario'
import alterarUsuario from '../../../actions/usuario/alterarUsuario'
import selecionarPerfis from '../../../actions/perfil/selecionarPerfis';
import limparPerfis from '../../../actions/perfil/limparPerfis';
import {
    renderFieldCheck,
    renderFieldCnpj,
    renderFieldCpf,
    renderFieldEmail,
    renderFieldNumerosPorcentagem,
    renderFieldTelefone,
    required,
    tamanhoPorcentagem,
    validarCNPJ
} from '../../../util/inputs';
import { URL } from '../../../util/ambienteActions';
import { SLOW_REQUEST_CONFIG } from '../../../util/loadingUtil';
import buscarUsuarioPorEmail from '../../../actions/usuario/buscarUsuarioPorEmail';
import { showSuccessMsg } from '../../../util/messagesUtil';
import UsuarioLink from './UsuarioLink';

const OPCAO_DESCONTO_MEIA_PASSAGEM = [
    { label: 'Aplicar desconto no valor da Empresa', value: 'EMPRESA' },
    { label: 'Aplicar desconto no valor da ANTT', value: 'ANTT' },
    { label: 'Aplicar desconto no valor da ANTT e Empresa', value: 'ANTT_EMPRESA' }];

export const validate = (values) => {
    const errors = {};
    if (!values.nome) {
        errors.nome = 'Campo obrigatório'
    }
    if (!values.email) {
        errors.email = 'Campo obrigatório'
    }

    return errors
};

const renderField = ({
    input,
    label,
    type,
    css,
    max,
    readOnly,
    meta: { touched, error }
}) => (
    <div>
        <label className='mt-2'>{label}</label>
        <div>
            <input {...input} type={type}
                className={css}
                maxLength={max}
                id={input.name}
                style={{ borderColor: touched && error ? 'red' : '' }}
                disabled={readOnly}
                readOnly={readOnly} />
            {touched
                && (error && <span style={{ color: 'red' }}>{error}</span>)}
        </div>
    </div>
);

export class ModalCadastrarUsuario extends React.Component {
    constructor(props) {
        super(props);
        this.fechar = this.fechar.bind(this);
        this.limparCampos = this.limparCampos.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);
        this.submit = this.submit.bind(this);
        this.state = {
            usuario: '',
            tiposQualificacao: [],
            perfisSelecionados: [],
            linksSelecionados: [],
        };
    }

    exibirComboOpcaoDescontoMeiaPassagem(event) {
        if (!this.props.opcaoDescontoMeiaPassagem) {
            this.props.changeFieldValue('formularioCadastroUsuario',
                'opcaoDescontoMeiaPassagem', { label: 'Aplicar desconto no valor da ANTT', value: 'ANTT' });
        }

        return (
            <div>
                <Select
                    {...event.input}
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    placeholder='Adicionar uma opção de desconto'
                    options={OPCAO_DESCONTO_MEIA_PASSAGEM}
                    onChange={(value) => {
                        event.input.onChange(value);
                    }}
                    onBlur={() => event.input.onBlur()}
                />
                {event.meta.touched
                    && (event.meta.error && <span style={{ color: 'red' }}>{event.meta.error}</span>)}
            </div>
        )
    }

    exibirComboPerfil(event) {
        const { perfis } = this.props
        return (
            <div>
                <Select
                    {...event.input}
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    placeholder='Adicionar um perfil...'
                    options={perfis}
                    onChange={(value) => {
                        event.input.onChange(value);
                        this.adicionarPerfil(value)
                    }}
                    onBlur={() => event.input.onBlur()}
                />
                {event.meta.touched
                    && (event.meta.error && <span style={{ color: 'red' }}>{event.meta.error}</span>)}
            </div>
        )
    }

    exibirOpcaoDescontoMeiaPassagemo() {
        const vendedor = this.props.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');

        if (vendedor.length > 0) {
            return (
                <div className="form-row mt-2">
                    <div className="col-12 col-sm-9 col-md-6">
                        <label>Opções de desconto de meia passagem </label>
                        <Field name='opcaoDescontoMeiaPassagem' required={true}
                            component={this.exibirComboOpcaoDescontoMeiaPassagem.bind(this)} />
                    </div>
                </div>
            )
        }
        return ''
    }

    adicionarPerfil(perfil) {
        if (this.props.idUsuario) {
            const url = `${URL}/perfil/${perfil.value}/usuario/${this.props.idUsuario}/empresa/${this.props.empresaSelecionada.id}/adicionar`;
            axios.post(url, SLOW_REQUEST_CONFIG)
                .then((resp) => {
                    if (resp.status === 200) {
                        const perfis = Object.assign([], this.props.perfisSelecionados);
                        const perfiJaExiste = perfis.filter(f => f.value === perfil.value);
                        if (perfiJaExiste.length === 0) {
                            perfis.push(perfil);
                            this.props.selecionarPerfis(perfis)
                        }
                    }
                })
        } else {
            const perfis = Object.assign([], this.props.perfisSelecionados);
            const perfiJaExiste = perfis.filter(f => f.value === perfil.value);
            if (perfiJaExiste.length === 0) {
                perfis.push(perfil);
                this.props.selecionarPerfis(perfis)
            }
        }
    }

    exibirAcrescimoMaximoPassagem() {
        return (
            <div className="form-row mt-2">
                <div className="col-12 col-sm-6 col-md-6">
                    <Field name='acrescimoMaximoPassagem' validate={[tamanhoPorcentagem]}
                        component={renderFieldNumerosPorcentagem}
                        css="form-control" label=" Acréscimo Máximo de Passagem(%)" />
                </div>
            </div>
        )
    }

    exibirComissao() {
        const vendedor = this.props.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');

        if (vendedor.length > 0) {
            if (this.props.empresaSelecionada.grupo === 'TCB') {
                return <div className="col-12 col-md-2">
                    <label>Comissão(%)</label>
                    <input type="text" className="form-control" readOnly={true} value='10.00' name='comissao' />
                </div>
            }
            return  <div className='col-12 col-md-2' style={{paddingTop: '22px'}}>
                <Field name='comissao' disabled validate={[required, tamanhoPorcentagem]}
                    component={renderFieldNumerosPorcentagem}
                        css="form-control" label="Comissão(%)" />
            </div>
            
        }
        this.props.changeFieldValue('formularioCadastroUsuario',
            'comissao', '00.00');

        return ''
    }

    exibirComissaoEncomenda() {
        const vendedor = this.props.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');

        if (vendedor.length > 0) {
            if (this.props.empresaSelecionada.grupo === 'TCB') {
                return <div className="form-group col-12 col-md-2">
                    <label>C.Encomenda(%)</label>
                    <input type="text" className="form-control" readOnly={true} value='10.00' name='comissaoEncomenda' />
                </div>
            }
            return <div className='col-12 col-md-2' style={{paddingTop: '22px'}}>
                    <Field name='comissaoEncomenda' disabled validate={[required, tamanhoPorcentagem]}
                        component={renderFieldNumerosPorcentagem}
                        css="form-control" label="C.Encomenda(%)" />
                </div>
        }
        this.props.changeFieldValue('formularioCadastroUsuario',
            'comissaoEncomenda', '00.00');

        return ''
    }

    exibirComissaoExcessoBagagem() {
        const vendedor = this.props.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');

        if (vendedor.length > 0) {
            if (this.props.empresaSelecionada.grupo === 'TCB') {
                return <div className="form-group col-12 col-md-2">
                    <label>C.Excesso Bagagem(%)</label>
                    <input type="text" className="form-control" readOnly={true} value='10.00' name='comissaoExcessoBagagem' />
                </div>
            }
            return <div className='col-12 col-md-2'>
                <Field name='comissaoExcessoBagagem' disabled validate={[required, tamanhoPorcentagem]}
                    component={renderFieldNumerosPorcentagem}
                        css="form-control" label="C.Excesso Bagagem(%)" />
            </div>
        }
        this.props.changeFieldValue('formularioCadastroUsuario',
            'comissaoExcessoBagagem', '00.00');

        return ''
    }

    exibirComissaoImpressaoBilhete() {
        const vendedor = this.props.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');

        if (vendedor.length > 0) {
            if (this.props.empresaSelecionada.grupo === 'TCB') {
                return <div className="form-group col-12 col-md-2">
                    <label>C.Impressao Bilhete(%)</label>
                    <input type="text" className="form-control" readOnly={true} value='10.00' name='comissaoImpressaoBilhete' />
                </div>
            }
            return <div className='col-12 col-md-2'>
                <Field name='comissaoImpressaoBilhete' disabled validate={[required, tamanhoPorcentagem]}
                    component={renderFieldNumerosPorcentagem}
                    css="form-control" label="C.Impressao Bilhete(%)" />
            </div>
        }
        this.props.changeFieldValue('formularioCadastroUsuario',
            'comissaoImpressaoBilhete', '00.00');

        return ''
    }

    exibirImpostoRetidoUsuaio() {
        const vendedor = this.props.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');

        if (vendedor.length > 0) {
            if (this.props.empresaSelecionada.grupo === 'TCB' || this.props.empresaSelecionada.grupo === 'BUSER' || this.props.empresaSelecionada.grupo === 'CIDAO') {
                if (this.props.empresaSelecionada.id == 808) {
                    return <div className="form-group">
                        <label>Imposto retido(%)</label>
                        <input type="text" className="form-control col-md-2" readOnly={true} value='0.00' name='impostoRetido' />
                    </div>
                }

                return <div className="form-group">
                    <label>Imposto retido(%)</label>
                    <input type="text" className="form-control col-md-2" readOnly={true} value='16.25' name='impostoRetido' />
                </div>
            } else
                return <div className="form-group">
                    <Field name='impostoRetido' validate={[required, tamanhoPorcentagem]}
                        component={renderFieldNumerosPorcentagem}
                        css="form-control col-md-2" label="imposto retido(%)" />
                </div>
        }
        this.props.changeFieldValue('formularioCadastroUsuario',
            'impostoRetido', '00.00');

        return ''
    }

    montarParametroUsuario(values) {                
        const comissoes = [{ tipoServico: 'RESERVA', porcentagem: values.comissao }, { tipoServico: 'ENCOMENDA', porcentagem: values.comissaoEncomenda },
            { tipoServico: 'EXCESSO_BAGAGEM', porcentagem: values.comissaoExcessoBagagem },  { tipoServico: 'IMPRESSAO_BILHETE', porcentagem: values.comissaoImpressaoBilhete }
        ];
        
        return {
            idAgencia: values.agencia ? values.agencia.value : null,
            id: values.idUsuario,
            nome: values.nome,
            email: values.email,
            roles: this.props.perfisSelecionados.map(perfil => perfil.value),            
            comissoes: comissoes,
            impostoRetido: values.impostoRetido,
            telefone: values.telefoneUsuario,
            cpf: values.cpf,
            venderCte: values.venderCte,
            venderValorANTT: values.venderValorANTT,
            vendeGratuidade: values.vendeGratuidade,
            vendaTEF: values.vendaTEF,
            cnpjTef: values.numeroCnpjTef,
            storeIdTef: values.storeIdTef,
            tipoDescontoMeiaPassagem: values.opcaoDescontoMeiaPassagem ? values.opcaoDescontoMeiaPassagem.value : 'EMPRESA',
            links: this.state.linksSelecionados,
            acrescimoMaximoPassagem: values.acrescimoMaximoPassagem,            
            habilitadoBloqueioEdicaoPassageiro: values.habilitadoBloqueioEdicaoPassageiro,
            habilitadoBloqueioReimpressaoCupom: values.habilitadoBloqueioReimpressaoCupom,
            habilitadoComissionamentoReimpresaoPassagem: values.habilitadoComissionamentoReimpresaoPassagem,
            habilitadoBloqueioListaPassageiro: values.habilitadoBloqueioListaPassageiro,
            habilitadoBloqueioBuscarReservasTerceiros: values.habilitadoBloqueioBuscarReservasTerceiros
        };
    }

    submit(values) {        
        this.props.cadastrarUsuario(this.montarParametroUsuario(values), this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Usuario cadastrado com sucesso');
                this.limparFormulario();
                this.fecharModal();
            })
    }

    fecharModal() {
        $('#modalCadastrarUsuario')
            .modal('hide');
        $('#modalCadastrarUsuario')
            .hide();
        $('.modalCadastrarUsuario')
            .hide();
    }

    limparFormulario() {
        this.props.reset('formularioCadastroUsuario');
        this.setState({ perfisSelecionados: [], usuario: '', linksSelecionados: [] });
        this.props.limparPerfis();
        this.limparLinks();
        this.props.buscarUsuario();
    }

    limparCampos() {
        this.props.changeFieldValue('formularioCadastroUsuario',
            'nome', '');
        this.props.changeFieldValue('formularioCadastroUsuario',
            'nomeUsuario', '');
        this.props.changeFieldValue('formularioCadastroUsuario',
            'email', '');
        this.props.changeFieldValue('formularioCadastroUsuario',
            'comissao', '');
        this.props.changeFieldValue('formularioAlterarUsuario',
            'impostoRetido', '');
        this.setState({ usuario: null });
        this.props.limparPerfis();
    }

    removerPerfil(perfil) {
        const perfis = Object.assign([], this.props.perfisSelecionados);
        const novaLista = perfis.filter(f => f.value !== perfil.value);
        this.props.selecionarPerfis(novaLista)
    }


    exibirPerfisSelecionados() {
        if (this.props.perfisSelecionados) {
            return this.props.perfisSelecionados.map(perfil => <div key={perfil.value} className="geral mb-1">
                <div className="resumo">
                    <div className="row">
                        <div className="col-lg-5 col-xl-5">
                            {perfil.label}
                        </div>
                        <div className="col-lg-5 col-xl-5">
                            <i className="material-icons nav-icon fa-1x" key={perfil.label}
                                style={{ cursor: 'pointer' }}
                                onClick={() => this.removerPerfil(perfil)}>&#xe872;</i>
                        </div>
                    </div>
                </div>
            </div>)
        }
        return ''
    }

    alterarValoresLinksSelecionados(links) {
        this.setState({ linksSelecionados: links });
    }

    limparLinks() {
        this.setState({ linksSelecionados: [] });
    }

    buscarUsuarioPorEmail(email) {
        if (email) {
            this.props.buscarUsuarioPorEmail(email, this.props.empresaSelecionada.id)
                .then((resp) => {
                    if (resp.payload.status === 200) {
                        if (resp.payload.data) {
                            this.props.changeFieldValue('formularioCadastroUsuario', 'nome', resp.payload.data.nome);
                            this.props.changeFieldValue('formularioCadastroUsuario', 'cpf', resp.payload.data.cpfCnpj);
                            this.props.changeFieldValue('formularioCadastroUsuario', 'telefoneUsuario', resp.payload.data.telefone);
                            const perfis = [];
                            resp.payload.data.rolesName.map(pf => perfis.push({
                                label: pf.descricao,
                                value: pf.valor
                            }));
                            this.props.selecionarPerfis(perfis);
                            this.setState({ usuario: resp.payload.data })
                        } else {
                            this.props.changeFieldValue('formularioCadastroUsuario', 'nome', '');
                            this.props.changeFieldValue('formularioCadastroUsuario', 'cpf', '');
                            this.props.changeFieldValue('formularioCadastroUsuario', 'telefoneUsuario', '');
                            this.setState({ usuario: '' })
                        }
                    }
                })
        }
    }

    fechar() {
        this.setState({ paginaAtual: 1 });
        this.limparFormulario();
        this.props.limparPerfis();
    }

    render() {
        const {
            handleSubmit, submitting, invalid
        } = this.props;
        return (
            <div className="modal fade show" id='modalCadastrarUsuario' role='dialog'
                aria-labelledby='modalCadastrarUsuario' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-lg'}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>Novo Usuário</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                onClick={() => this.fechar()}>
                                <i className="material-icons">
                                    &#xe5cd;
                                </i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit(this.submit)}>
                                <div className="form-row">
                                    <div className="col-12 col-sm-6 col-md-6">
                                        <Field name="email" type="email" component={renderFieldEmail} label="E-mail:"
                                            css="form-control" readOnly={false} validate={[required]}
                                            onBlur={e => this.buscarUsuarioPorEmail(e.target.value)} />
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-6">
                                        <Field name="cpf" type="text" component={renderFieldCpf} label="CPF:"
                                            validate={[required]}
                                            css="form-control" readOnly={this.state.usuario} />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="col-12 col-sm-9 col-md-9">
                                        <Field name="nome" type="text" validate={[required]} component={renderField}
                                            label="Nome Completo:"
                                            css="form-control" readOnly={this.state.usuario} />
                                    </div>
                                    <div className="col-12 col-sm-3 col-md-3">
                                        <Field name="telefoneUsuario" type="text"
                                            component={renderFieldTelefone}
                                            css="form-control" label="Telefone" readOnly={this.state.usuario} />
                                    </div>
                                </div>

                                <div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-6">
                                            <label>Perfil usuário</label>
                                            <Field id='perfil' name='perfil'
                                                component={this.exibirComboPerfil.bind(this)} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-6">
                                            <div className="lista-table-media">
                                                {this.exibirPerfisSelecionados()}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='venderCte' type="checkbox" component={renderFieldCheck}
                                                label="Vender com cte"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='venderValorANTT' type="checkbox" component={renderFieldCheck}
                                                label="Vender com valor antt"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='vendeGratuidade' type="checkbox" component={renderFieldCheck}
                                                label="Vender Gratuidade"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>                                    
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoBloqueioEdicaoPassageiro' type="checkbox" component={renderFieldCheck}
                                                label="Bloquear Edição de Passagens"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoBloqueioReimpressaoCupom' type="checkbox" component={renderFieldCheck}
                                                label="Bloquear Impressão de Passagens"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoBloqueioListaPassageiro' type="checkbox" component={renderFieldCheck}
                                                label="Bloquear lista de passageiro"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoBloqueioBuscarReservasTerceiros' type="checkbox" component={renderFieldCheck}
                                                label="Bloquear Cancelar/Remarcar/Em Aberto Reservas de Terceiros"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='vendaTEF' type="checkbox" component={renderFieldCheck}
                                                label="Vender TEF"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    {this.props.vendaTEF ? <><div className="form-row mb-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name="numeroCnpjTef" css='form-control' validate={[required, validarCNPJ]}
                                                component={renderFieldCnpj} label="Número CNPJ"/>
                                        </div>
                                    </div>
                                    <div className="form-row mb-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name="storeIdTef" type="text"
                                                component={renderField}                                
                                                label="Store ID TEF"
                                                css="form-control col-md-4"
                                                validate={[required]}
                                            />
                                        </div>
                                    </div></>: ''}
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoComissionamentoReimpresaoPassagem' type="checkbox" component={renderFieldCheck}
                                                label="Habilitar Comissao Sobre Passagens Reimpressas de Terceiros"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    {this.exibirAcrescimoMaximoPassagem()}
                                    <div className="form-row">
                                        {this.exibirComissao()}
                                        {this.exibirComissaoEncomenda()}
                                        {this.exibirComissaoExcessoBagagem()}
                                        {this.exibirComissaoImpressaoBilhete()}
                                    </div>
                                    {this.exibirImpostoRetidoUsuaio()}
                                    {this.exibirOpcaoDescontoMeiaPassagemo()}
                                </div>

                                <div className="form-row">
                                    <UsuarioLink
                                        linksSelecionados={this.state.linksSelecionados}
                                        alterarValoresLinksSelecionados={this.alterarValoresLinksSelecionados.bind(this)}
                                        verificaSeNaoFoiAlteradoLinks={null}
                                        classCss={'campoUrl'}
                                        ehUsuarioAgencia={false}
                                    />
                                </div>

                                <div className="form-group area-codigo">
                                    <Field name="idUsuario" type="hidden" component={renderField}
                                        css="form-control col-md-12" />
                                </div>
                                <div className="modal-footer">
                                    <button id="btn-salvar" type="submit" disabled={invalid || submitting}
                                        className="btn btn-laranja">Salvar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        initialValues: {
            acrescimoMaximoPassagem: '00.00'
        },
        opcaoDescontoMeiaPassagem: formValueSelector('formularioCadastroUsuario')(state, 'opcaoDescontoMeiaPassagem'),
        perfisSelecionados: state.perfisSelecionados,
        empresaSelecionada: state.empresaSelecionada,
        paginaAtual: state.paginaAtualUsuario,
        registrosPorPagina: state.registrosPorPaginaUsuario,
        usuarioSistema: state.usuarioSelecionado ? state.usuarioSelecionado.usuarioSistema : '',
    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        cadastrarUsuario,
        selecionarPerfis,
        buscarUsuarioPorEmail,
        alterarUsuario,
        limparPerfis
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioCadastroUsuario'
})(ModalCadastrarUsuario));
